import { ThemeOptions } from '@mui/material';
import { carrotColors } from '../tokens';

export const palette: ThemeOptions['palette'] = {
    background: {
        default: carrotColors.lightPampas,
        paper: carrotColors.white,
    },
    text: {
        primary: '#141414',
        secondary: '#2D2D2D',
        tertiary: '#5C5C5C',
        disabled: '#8A8A8A',
    },
    border: {
        main: '#2D2D2D',
        light: '#8A8A8A',
        dark: '#141414',
    },
    primary: {
        main: carrotColors.carrotOrange,
        light: carrotColors.veryLightCarrotOrange,
        dark: carrotColors.darkCarrotOrange,
        contrastText: carrotColors.white,
    },
    secondary: {
        main: '#2D2D2D',
        light: '#F5F5F5',
        dark: '#141414',
        contrastText: carrotColors.white,
    },
    error: {
        main: '#A1392B',
        light: '#FDEEED',
        dark: '#812D22',
        contrastText: carrotColors.white,
    },
    warning: {
        main: '#FAEB61',
        light: '#FDF5B0',
        dark: '#F9E639',
        contrastText: carrotColors.black,
    },
    info: {
        main: '#305F73',
        light: '#E2EEF3',
        dark: '#244656',
        contrastText: carrotColors.white,
    },
    success: {
        main: '#2C634B',
        light: '#E6EFEA',
        dark: '#265440',
        contrastText: carrotColors.white,
    },
    divider: '#B9B9B9',
    focusRing: '#2196F3',
    components: {
        backdrop: {
            bgcolor: carrotColors.black40,
        },
        tooltip: {
            bgcolor: '#121212',
            color: '#FFF',
        },
        outlinedInput: {
            disabled: {
                bgcolor: carrotColors.lightGrey,
            },
        },
    },
};
